import type { ConditionMarket } from "@/hooks/useApi";

export const CONDITION_ORDER = ["NM", "LP", "MP", "HP", "DMG"] as const;
export const CONDITION_NAME: Record<(typeof CONDITION_ORDER)[number], string> = {
  NM: "Near Mint",
  LP: "Lightly Played",
  MP: "Moderately Played",
  HP: "Heavily Played",
  DMG: "Damaged",
};
export type RawCondition = (typeof CONDITION_ORDER)[number];
export type ConditionPoint = { as_of_date: string; price: number; };

export function conditionSeries(
  market: ConditionMarket | undefined,
  condition: RawCondition,
  days: number,
  today = new Date(),
): ConditionPoint[] {
  const from = new Date(today);
  from.setUTCDate(from.getUTCDate() - days);
  const start = from.toISOString().slice(0, 10);
  return (market?.points ?? [])
    .filter((point) => point.condition === condition && point.observed_on >= start)
    .map((point) => ({ as_of_date: point.observed_on, price: Number(point.price) }));
}

export function latestConditionPrices(market: ConditionMarket | undefined) {
  const points = [...(market?.points ?? [])].reverse();
  const latest = (condition: RawCondition) =>
    points.find((point) => point.condition === condition) ?? null;
  return {
    NM: latest("NM"),
    LP: latest("LP"),
    MP: latest("MP"),
    HP: latest("HP"),
    DMG: latest("DMG"),
  };
}
